/* Local scoped-deployment candidate; not uploaded. Legacy defaults remain Draft-only.
 * Single-tab, one-hop handoff for an unsubmitted real click.
 * No network, Google commands, identity, raw labels, query strings or bootstrap.
 * Call onPageShow from the owner's lifecycle handler to reject BFCache replay. */
(function (scope, factory) {
  'use strict';
  var deploymentApi = typeof module === 'object' && module.exports ? require('../bh-deployment-scope.js') : scope && scope.BhDeploymentScope;
  var api = factory(deploymentApi);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (scope) scope.BhClickHandoff = api;
})(typeof window !== 'undefined' ? window : null, function (deploymentApi) {
  'use strict';

  var DRAFT_ID = '196364992838';
  var STORAGE_KEY = 'bh-click-handoff:' + DRAFT_ID + ':v1';
  var TTL_MS = 45000;
  var MAX_BYTES = 4096;
  var AREAS = {
    home_banner: { entries: ['image', 'cta'], keys: ['banner_index'] },
    announcement: { entries: ['cta'], keys: ['position'] },
    menu: { entries: ['menu_item'], keys: ['menu_type', 'menu_item_id', 'position'] },
    collection_promo: { entries: ['image', 'cta'], keys: ['collection_handle', 'position'] },
    load_more: { entries: ['button'], keys: ['collection_handle'] },
    description: { entries: ['accordion_header'], keys: ['product_handle'] }
  };
  var PAGE_TYPES = ['home', 'collection', 'product', 'page'];

  function ownValue(object, key) {
    var descriptor = Object.getOwnPropertyDescriptor(object, key);
    return descriptor && Object.prototype.hasOwnProperty.call(descriptor, 'value') ? descriptor.value : undefined;
  }

  function plainObject(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
    var prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
  }

  function identifier(value) {
    return typeof value === 'string' && value.length > 0 && value.length <= 100 &&
      /^[a-zA-Z0-9_:.\-]+$/.test(value) && !/^\d{7,}$/.test(value) &&
      !/^\d[\d().\-]{5,}\d$/.test(value);
  }

  function byteLength(value) {
    try { return unescape(encodeURIComponent(value)).length; } catch (_) { return MAX_BYTES + 1; }
  }

  function create(options) {
    options = options || {};
    var win = options.window;
    if (!win || !win.document) throw new Error('A storefront window is required.');
    var now = options.now || function () { return Date.now(); };
    var consumed = false;
    var restored = false;
    var invalidated = false;
    var expiryTimer = null;
    var expiryGeneration = 0;
    var explicitDeployment = Object.prototype.hasOwnProperty.call(options, 'deployment');
    var deployment = ownValue(options, 'deployment');
    function resolvedDeployment() {
      try {
        var theme = win.Shopify && win.Shopify.theme;
        return deploymentApi && deploymentApi.resolve(deployment, {
          themeId: theme && theme.id, role: theme && theme.role,
          hostname: new win.URL(win.location.href).hostname
        });
      } catch (_) { return null; }
    }
    var initialScope = explicitDeployment ? resolvedDeployment() : null;
    var storageKey = initialScope ? initialScope.storageKey : STORAGE_KEY;
    var recordSchema = initialScope && initialScope.mode === 'production' ? 2 : 1;
    function makeRecord(createdAt, source, target, params) {
      var record = { schema: recordSchema, createdAt: createdAt, sourcePath: source, targetPath: target, params: params };
      if (recordSchema === 2) record.deploymentKey = storageKey;
      else record.draftThemeId = DRAFT_ID;
      return record;
    }

    function draftAllowed() {
      try {
        if (explicitDeployment) {
          var currentScope = resolvedDeployment();
          return options.enabled === true && !!initialScope && !!currentScope &&
            currentScope.storageKey === storageKey && (options.ttlMs == null || options.ttlMs === TTL_MS);
        }
        var theme = win.Shopify && win.Shopify.theme;
        return options.enabled === true && String(options.draftThemeId) === DRAFT_ID &&
          (options.ttlMs == null || options.ttlMs === TTL_MS) && theme &&
          String(theme.id) === DRAFT_ID && typeof theme.role === 'string' && theme.role !== 'main';
      } catch (_) { return false; }
    }

    function consent() {
      try {
        var privacy = win.Shopify && win.Shopify.customerPrivacy;
        if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return null;
        var value = privacy.analyticsProcessingAllowed();
        return typeof value === 'boolean' ? value : null;
      } catch (_) { return null; }
    }

    function publicPath(value) {
      if (typeof value !== 'string' || !value || /[\u0000-\u001f\u007f]/.test(value)) return null;
      try {
        var current = new win.URL(win.location.href);
        var url = new win.URL(value, current.href);
        if (!/^https?:$/.test(url.protocol) || url.origin !== current.origin || url.username || url.password) return null;
        var path = url.pathname;
        var inspected = decodeURIComponent(path);
        if (path.length > 100 || /%2f|%5c|%25/i.test(path) ||
            /[\u0000-\u001f\u007f@\\]/.test(inspected) ||
            /(?:^|\/)(?:account|accounts|admin|checkout|checkouts|cart|carts|customer|customers|orders|password|tokens?)(?:\/|$)/i.test(inspected) ||
            /(?:email|e-mail|phone|telephone|mobile|customer_id|customerid|token|password)\s*=/i.test(inspected) ||
            /(?:^|[^a-z\d])\+?\d[\d\s().\-]{5,}\d(?:$|[^a-z\d])/i.test(inspected)) return null;
        return path;
      } catch (_) { return null; }
    }

    function safeParams(value, targetPath) {
      if (!plainObject(value)) return null;
      var area = ownValue(value, 'bh_area');
      if (!Object.prototype.hasOwnProperty.call(AREAS, area)) return null;
      var definition = AREAS[area];
      var entry = ownValue(value, 'entry_type');
      var page = ownValue(value, 'page_type');
      var content = ownValue(value, 'content_id');
      var block = ownValue(value, 'block_key');
      if (definition.entries.indexOf(entry) < 0 || PAGE_TYPES.indexOf(page) < 0 ||
          !identifier(content) || !identifier(block)) return null;
      var result = { bh_area: area, entry_type: entry, content_id: content, block_key: block, page_type: page };
      for (var i = 0; i < definition.keys.length; i += 1) {
        var key = definition.keys[i];
        var item = ownValue(value, key);
        if (key === 'banner_index' || key === 'position') {
          if (!Number.isInteger(item) || item < 1 || item > 10000) return null;
        } else if (key === 'menu_type') {
          if (item !== 'product_category' && item !== 'collection_series') return null;
        } else if (!identifier(item)) return null;
        result[key] = item;
      }
      var target = ownValue(value, 'target_url');
      if (target !== undefined) {
        if (publicPath(target) !== targetPath) return null;
        result.target_url = targetPath;
      }
      // Labels are reconstituted by the sender's current controlled dictionary.
      return result;
    }

    function cancelExpiry() {
      expiryGeneration += 1;
      if (expiryTimer !== null) {
        try { win.clearTimeout(expiryTimer); } catch (_) { /* stale callback is generation-guarded */ }
        expiryTimer = null;
      }
    }

    function clear() {
      cancelExpiry();
      if (explicitDeployment && !initialScope) return false;
      try { win.sessionStorage.removeItem(storageKey); return true; } catch (_) { return false; }
    }

    function navigationRestored() {
      if (restored) return true;
      try {
        var navigation = win.performance && win.performance.getEntriesByType('navigation');
        return Boolean(navigation && navigation[0] &&
          (navigation[0].type === 'reload' || navigation[0].type === 'back_forward'));
      } catch (_) { return true; }
    }

    function validRecord(record) {
      if (!plainObject(record) || ownValue(record, 'schema') !== recordSchema) return null;
      if (recordSchema === 2 ? ownValue(record, 'deploymentKey') !== storageKey : ownValue(record, 'draftThemeId') !== DRAFT_ID) return null;
      var createdAt = ownValue(record, 'createdAt');
      var timestamp = now();
      if (!Number.isFinite(createdAt) || !Number.isFinite(timestamp) || createdAt > timestamp || timestamp - createdAt >= TTL_MS) return null;
      var source = ownValue(record, 'sourcePath');
      var target = ownValue(record, 'targetPath');
      if (publicPath(source) !== source || publicPath(target) !== target || source === target) return null;
      var params = safeParams(ownValue(record, 'params'), target);
      if (!params) return null;
      return makeRecord(createdAt, source, target, params);
    }

    function maintainExpiry() {
      cancelExpiry();
      if (!draftAllowed()) return false;
      var raw;
      var record;
      try {
        raw = win.sessionStorage.getItem(storageKey);
        if (raw == null) return true;
        record = byteLength(raw) <= MAX_BYTES && validRecord(JSON.parse(raw));
      } catch (_) { invalidated = true; clear(); return false; }
      if (!record || typeof win.setTimeout !== 'function' || typeof win.clearTimeout !== 'function') {
        invalidated = true;
        clear();
        return false;
      }
      var remaining = record.createdAt + TTL_MS - now();
      if (!Number.isFinite(remaining) || remaining <= 0) { clear(); return false; }
      var generation = expiryGeneration;
      try {
        expiryTimer = win.setTimeout(function () {
          if (generation !== expiryGeneration) return;
          expiryTimer = null;
          // Recheck the current single record: another owner must not lose a
          // newer real click to this record's old timer. Never renew createdAt.
          maintainExpiry();
        }, remaining);
        if (expiryTimer == null) throw new Error('No expiry timer.');
        return true;
      } catch (_) { invalidated = true; clear(); return false; }
    }

    function persist(input) {
      if (!draftAllowed()) return false;
      var allowed = consent();
      if (allowed === false) { invalidated = true; clear(); return false; }
      if (allowed !== true || !plainObject(input)) return false;
      var source = publicPath(ownValue(input, 'sourcePath'));
      var target = publicPath(ownValue(input, 'targetPath'));
      if (!source || source !== publicPath(win.location.href) || !target || source === target) { clear(); return false; }
      var inputTime = ownValue(input, 'createdAt');
      var record = validRecord(makeRecord(inputTime == null ? now() : inputTime, source, target, ownValue(input, 'params')));
      if (!record) { clear(); return false; }
      try {
        var raw = JSON.stringify(record);
        if (byteLength(raw) > MAX_BYTES) { clear(); return false; }
        win.sessionStorage.setItem(storageKey, raw);
        if (!maintainExpiry()) return false;
        invalidated = false;
        return true;
      } catch (_) { clear(); return false; }
    }

    function read() {
      if (!draftAllowed() || consumed || invalidated) return null;
      // A newly opened tab can receive a copy of its opener's sessionStorage.
      // Such a document is not proven to be the source tab's immediate hop.
      try {
        if (win.opener != null) { invalidated = true; clear(); return null; }
      } catch (_) { invalidated = true; clear(); return null; }
      if (navigationRestored()) { invalidated = true; clear(); return null; }
      var raw;
      try { raw = win.sessionStorage.getItem(storageKey); } catch (_) { return null; }
      if (raw == null) return null;
      var record;
      try { record = byteLength(raw) <= MAX_BYTES && validRecord(JSON.parse(raw)); } catch (_) { record = null; }
      if (!record || record.targetPath !== publicPath(win.location.href) ||
          record.sourcePath !== publicPath(win.document.referrer)) { invalidated = true; clear(); return null; }
      var allowed = consent();
      if (allowed === false) { invalidated = true; clear(); return null; }
      if (allowed !== true) return null;
      return record;
    }

    function take() {
      var record = read();
      if (!record) return null;
      // Remove before returning. An exception never becomes a reported transfer.
      consumed = true;
      if (!clear()) { invalidated = true; return null; }
      return record;
    }

    function onPageShow(event) {
      if (event && event.persisted === true) { restored = true; invalidated = true; clear(); }
    }

    // Cleanup does not need consent and cannot send an event or read identity.
    // Browser-paused timers can run late; read/take still enforce the same TTL.
    maintainExpiry();
    return { persist: persist, read: read, take: take, clear: clear, onPageShow: onPageShow };
  }

  return { create: create, STORAGE_KEY: STORAGE_KEY, TTL_MS: TTL_MS, MAX_BYTES: MAX_BYTES };
});
